import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";
import { canOpenRoute } from "../lib/permissions";
import { Button } from "./ui/button";

export default function ProtectedRoute({ children }) {
  const { user, loading, authError, retryAuth, sessionKey } = useAuth();
  const location = useLocation();

  if (authError && !loading) return <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background p-6">
    <p role="alert" className="max-w-md text-center">{authError}</p><Button onClick={retryAuth}>Riprova</Button>
  </div>;
  if (loading || user === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (!canOpenRoute(user, location.pathname)) return <Navigate to="/" replace />;
  return <React.Fragment key={sessionKey}>{children}</React.Fragment>;
}
